import React from 'react'
import { Link } from 'react-router-dom'

export const getResourceColumns = (isStudent, role, layout, slug, handleDelete, isDarkMode = false) => {
	const columns = [
		{
			name: 'Topic',
			selector: (row) => row.pname,
			sortable: true,
			width: isStudent ? '17%' : '15%',
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		},
		{
			name: 'How to use it',
			selector: (row) => row.howuse,
			sortable: true,
			width: isStudent ? '30%' : '25%',
			cell: (row) => (
				<a
					href={row.link1}
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: isDarkMode ? '#0dcaf0' : '#0d6efd',
						textDecoration: 'none',
					}}
					onMouseEnter={(e) => {
						e.target.style.textDecoration = 'underline'
					}}
					onMouseLeave={(e) => {
						e.target.style.textDecoration = 'none'
					}}
				>
					{row.howuse}
				</a>
			),
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		},
		{
			name: 'Grade',
			selector: (row) => row.grade,
			sortable: true,
			width: isStudent ? '11%' : '10%',
			center: true,
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		},
		{
			name: 'Date',
			selector: (row) => row.rdate,
			sortable: true,
			width: isStudent ? '17%' : '15%',
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		},
		{
			name: 'Instructor',
			selector: (row) => `${row.name} ${row.surname}`,
			sortable: true,
			width: isStudent ? '25%' : '20%',
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		}
	]

	// Add Actions column only for instructors
	if (!isStudent) {
		columns.push({
			name: 'Actions',
			width: '15%',
			center: true,
			cell: (row) => (
				<div className="d-flex gap-1">
					<Link
						to={`${process.env.PUBLIC_URL}/${role}/instructor-resource-edit/${slug}/Update/${row.id}/${layout}`}
						className="btn btn-success btn-sm"
					>
						<i className="fa fa-edit me-1"></i>
					</Link>
					<button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.id)}>
						 <i className="fa fa-trash"></i>
					</button>
				</div>
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
			style: {
				color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
			}
		})
	}

	return columns
}
